export default __webpack_public_path__ + "4f59893d0384c190ea14d4ba50f4306e.svg";